import { useBrandTheme } from "@/features/theme/hooks/useBrandTheme";
import type { NavigationPosition } from "@/features/theme/types/brandTheme.type";

export const useNavigationPosition = (): NavigationPosition => {
  const { brandTheme } = useBrandTheme();
  return brandTheme?.navigationPosition ?? "left";
};
